import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type Theme = 'paper' | 'light' | 'dark';

// PlanXi Light is the default; Dark is its night palette; paper (Worksnip
// cream/coral) is a selectable alternative at the end of the cycle.
const THEME_ORDER: Theme[] = ['light', 'dark', 'paper'];

function applyTheme(theme: Theme) {
  if (typeof document !== 'undefined') {
    document.documentElement.dataset.theme = theme;
  }
}

interface ThemeState {
  theme: Theme;
  setTheme: (theme: Theme) => void;
  cycleTheme: () => void;
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set, get) => ({
      theme: 'light',
      setTheme: (theme) => {
        applyTheme(theme);
        set({ theme });
      },
      cycleTheme: () => {
        const next = THEME_ORDER[(THEME_ORDER.indexOf(get().theme) + 1) % THEME_ORDER.length];
        applyTheme(next);
        set({ theme: next });
      },
    }),
    {
      name: 'acechem-theme',
      // Re-apply the persisted theme to <html> as soon as the store rehydrates,
      // so a hard reload keeps the user's choice (index.html defaults to paper).
      onRehydrateStorage: () => (state) => {
        if (state) applyTheme(state.theme);
      },
    }
  )
);
